import Form from 'antd/lib/form';

export const useAppForm = Form.useForm;
